import React from 'react';
import Responsive from 'react-responsive';
import { MOBILE_BREAKPOINT_MAX, OLD_MOBILE_BREAKPOINT_MAX } from '../../../config/consts';

const Tablet = props => (
    <Responsive
        {...props}
        minWidth={MOBILE_BREAKPOINT_MAX + 1}
        maxWidth={OLD_MOBILE_BREAKPOINT_MAX}
    />
);

export default Tablet;
